// extracted by mini-css-extract-plugin
export default {"root":"pending-approval-badge_root__phpPY","note":"pending-approval-badge_note__HUP55","icon":"pending-approval-badge_icon__KAQQr"};